import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Button,
    Grid,
    useMediaQuery,
    useTheme,
    Link,
    CircularProgress,
} from "@mui/material";
import { learnerPracticeNotes } from "../../services/AttendanceServices";
import { toast } from "react-toastify";
import ErrorScreen from "../ErrorScreen";

const DailyPracticeNotes = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const storedPath = localStorage.getItem("notesPath");
    const parts = storedPath?.split("/") || [];
    const noteId = parts.length >= 4 ? parts[3] : null;

    useEffect(() => {
        if (!localStorage.getItem("notesPath")) {
            const message = "Please scan QR code for daily practice notes."
            setErrorMessage(message);
        } else {
            const fetchData = async () => {
                setLoading(true);
                try {
                    if (noteId) {
                        const data = { note_code: noteId }
                        const response = await learnerPracticeNotes(data);
                        setData(response?.data?.data);
                    }
                } catch (error) {
                    let message =
                        error.response?.data?.message ||
                        "Something went wrong. Please try again later.";
                    toast.error(message);

                } finally {
                    setLoading(false);
                }
            }
            fetchData()
        }
    }, [noteId]);
    if (loading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
            }}
        >   {errorMessage ? (
            <ErrorScreen message={errorMessage} />

        ) : (
            <Card
                sx={{
                    maxWidth: isMobile ? "100%" : 600,
                    width: "100%",
                    boxShadow: 3,
                    borderRadius: 3,
                    minWidth: isMobile ? "100%" : 500
                }}
            >
                <CardContent>
                    <Typography
                        variant="h6"
                        sx={{
                            textAlign: "center",
                            fontWeight: "bold",
                            mb: 2,
                        }}
                    >
                        Practice Notes
                    </Typography>


                    <Grid container spacing={2} sx={{ paddingLeft: "15%" }}>
                        {/* <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Coding Plan:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1">{data?.makerPlan ||" - "}</Typography>
            </Grid> */}

                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Module:
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1">
                                {data?.module?.moduleName || "-"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Topic:
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1">
                                {data?.topic?.topicName || "-"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Note:
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1">
                                {data?.note_name || "-"}
                            </Typography>
                        </Grid>
                    </Grid>
                    {!errorMessage && (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                mt: 3,
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                    minWidth: 100,
                                    padding: "8px 16px",
                                    textTransform: "none",
                                }}
                                disabled={!data?.topic?.topic_pdfPath}
                                onClick={() =>
                                    window.open(data?.topic?.topic_pdfPath, "_blank")
                                }
                            >
                                VIEW  MY PRACTICE NOTES
                            </Button>
                        </Box>
                    )}
                </CardContent>
            </Card>)}
        </Box>
    );
};

export default DailyPracticeNotes;
